import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { CdkDetailRowDirective } from '../directives/cdk-detail-row.directive';
import { ChartService } from './chart/chart.service';
import { CIKService } from './cik/cik.service';
import { DateTimeService } from './date-time.service';
import { DetailsService } from './details/details.service';
import { FilingsService } from './filings.service';
import { NewsService } from './news/news.service';
import { QuoteService } from './quote/quote.service';
import { RelationsService } from './relations.service';
import { SubHeaderComponent } from './sub-header/sub-header.component';

@Component({
  selector: 'app-filings',
  templateUrl: './filings.component.html',
  styleUrls: ['./filings.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ]
})
export class FilingsComponent implements OnInit, OnDestroy {
  @ViewChild(SubHeaderComponent) subHeader: SubHeaderComponent;
  dataSource;
  displayedColumns = [
    'symbol',
    'company',
    'transactionValue',
    'transactionPricePerShare',
    'transactionShares',
    // 'sharesOwnedFollowingTransaction',
    'isTenPercentOwner',
    'transactionDate',
    'updated',

  ];
  filingsSubscription: Subscription;
  ROW_HEIGHT = 32;
  openedRow: CdkDetailRowDirective;

  constructor(
    private filingsService: FilingsService,
    private cikService: CIKService,
    private cdr: ChangeDetectorRef,
    private relationsService: RelationsService,
    private newsService: NewsService,
    private chartService: ChartService,
    private quoteService: QuoteService,
    private detailsService: DetailsService,
    public dtService: DateTimeService
  ) { }

  ngOnInit(): void {
    this.filingsService.fetchData();
    this.filingsSubscription = this.filingsService.filingsSubject$.subscribe(res => {
      this.dataSource = res;
      this.dataSource = new MatTableDataSource(res);
      if (this.subHeader) {
        this.dataSource.paginator = this.subHeader.paginator;
        this.displayedColumns = [
          'symbol',
          'company',
          'transactionValue',
          'transactionPricePerShare',
          'transactionShares',
          // 'sharesOwnedFollowingTransaction',
          'isTenPercentOwner',
          'transactionDate',
          'updated',

        ];
      }
      this.cdr.detectChanges();
    });
  }

  getRowId(row) {
    const data = this.dataSource.data;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < data.length; i++) {
      if (data[i] === row) {
        return i;
      }
    }
  }

  rowClicked(e, row) {
    setTimeout(() => {
      this.detailsService.onRowSelected(row);
    }, 300);
    const matTable = document.getElementById('matTable');
    const top = ((this.getRowId(row) - (this.subHeader.paginator.pageIndex * this.subHeader.paginator.pageSize)) * this.ROW_HEIGHT);
    matTable.scroll({ top, behavior: 'smooth' });
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, closeButtonClicked?: boolean): void {
    if (cdkDetailRow.expanded && !closeButtonClicked) {
      setTimeout(() => {
        this.chartService.getChart('1 months', cdkDetailRow.currRow.symbol);
        this.newsService.getNews(cdkDetailRow.currRow.symbol);
        this.quoteService.getQuote(cdkDetailRow.currRow.symbol);
      }, 150);
      this.cikService.getCIK(cdkDetailRow.currRow.CIK);

    }
    if (this.openedRow && this.openedRow.expanded) {
      this.openedRow.toggle();
    }
    this.openedRow = cdkDetailRow.expanded ? cdkDetailRow : undefined;
  }

  getRelations(tr) {
    return this.relationsService.concatRelations(tr, 'new line');
  }

  closeRow() {
    this.onToggleChange(this.openedRow, true);
  }

  ngOnDestroy() {
    this.filingsSubscription.unsubscribe();
  }

}

